import React from 'react';
import '../Go/Go.css';

const Go = () => {
  return (
    <div className="go-container">
      <div className="go-left">
        <h1>Happy To Discuss About Your Requirement</h1>
        <p>We understand the needs for professionalism, privacy and confidentiality in both our relationship with our customers as well as your clients.</p>
      </div>
      <div className="go-right">
        <button className="contact-btn-go">Contact Now</button>
      </div>
    </div>
  );
};

export default Go;
